(function () {
  if (window.ClubFreebieGuardLoaded) return;
  window.ClubFreebieGuardLoaded = true;

  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  var KNOWN_CODES_ATTRIBUTE = '_club_freebie_known_codes';
  var DEFAULT_PREFIXES = ['CLUBFREE'];

  var isRunning = false;
  var isQueued = false;
  var debounceTimer = null;
  var uiDebounceTimer = null;

  function cartUrl(path) {
    return ROOT + path.replace(/^\//, '');
  }

  function getSectionConfig() {
    var script = document.querySelector('[data-club-freebie-section-config]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('[ClubFreebieGuard] Invalid section config JSON', error);
      return {};
    }
  }

  function getConfig() {
    var sectionConfig = getSectionConfig();
    var globalAllowed = window.__clubFreebieCustomerAllowed === true;
    var globalLoginUrl = window.__clubFreebieLoginUrl || '/account/login';
    var prefixes = Array.isArray(window.__clubFreebieCodePrefixes)
      ? window.__clubFreebieCodePrefixes
      : DEFAULT_PREFIXES;

    return {
      customerAllowed: typeof sectionConfig.customerAllowed === 'boolean'
        ? sectionConfig.customerAllowed
        : globalAllowed,
      loginUrl: sectionConfig.loginUrl || globalLoginUrl,
      currency: sectionConfig.currency || window.__clubFreebieCurrency || 'EUR',
      locale: sectionConfig.locale || window.__clubFreebieLocale || 'lt-LT',
      allowPreThresholdAdd: typeof sectionConfig.allowPreThresholdAdd === 'boolean'
        ? sectionConfig.allowPreThresholdAdd
        : true,
      codePrefixes: prefixes.map(function (prefix) {
        return String(prefix || '').trim().toUpperCase();
      }).filter(Boolean),
      texts: Object.assign({
        login: 'Prisijungti prie Klubo',
        unlocked: 'Atsiimti dovaną',
        preThresholdAdd: 'Pasirinkti dovaną',
        missing: 'Trūksta [amount]',
        inCart: 'Dovana jau krepšelyje',
        otherGift: 'Dovana jau pasirinkta',
        adding: 'Pridedama...',
        error: 'Nepavyko pridėti'
      }, sectionConfig.texts || {})
    };
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function addVariantAsFreebie(variantId, thresholdEur, thresholdCents, discountCode) {
    var normalizedThresholdEur = String(thresholdEur || '').trim();
    var normalizedCode = String(discountCode || '').trim();
    var rule = 'CLUB-THRESHOLD' + normalizedThresholdEur + '-' + normalizedCode;

    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              _club_freebie: 'true',
              _club_freebie_threshold: normalizedThresholdEur,
              _club_freebie_threshold_cents: String(thresholdCents || ''),
              _club_freebie_code: normalizedCode,
              _club_freebie_rule: rule
            }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add freebie failed');
      return response.json();
    });
  }

  function updateDiscounts(discountString) {
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: discountString || ''
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function updateKnownCodesAttribute(codes) {
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [KNOWN_CODES_ATTRIBUTE]: codes.join(',')
        }
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function getVariantId(item) {
    return Number(item.variant_id || item.id || 0);
  }

  function getProperties(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? item.properties
      : {};
  }

  function getProp(props, name) {
    if (!props) return '';

    if (props[name] !== undefined && props[name] !== null) {
      return props[name];
    }

    var wanted = String(name).toLowerCase();
    var keys = Object.keys(props);

    for (var i = 0; i < keys.length; i++) {
      if (String(keys[i]).toLowerCase() === wanted) {
        return props[keys[i]];
      }
    }

    return '';
  }

  function parseFreebieRuleString(rule) {
    if (!rule) return null;

    var match = String(rule).match(/^CLUB-THRESHOLD(\d+(?:\.\d+)?)-(.+)$/i);
    if (!match) return null;

    var thresholdEur = Number(match[1]);
    var code = String(match[2] || '').trim();

    if (!thresholdEur || !code) return null;

    return {
      thresholdCents: Math.round(thresholdEur * 100),
      discountCode: code
    };
  }

  function getFreebieRuleFromItem(item) {
    var props = getProperties(item);
    var isFreebie = String(getProp(props, '_club_freebie') || '').toLowerCase() === 'true';
    var ruleString = String(getProp(props, '_club_freebie_rule') || '').trim();

    if (!isFreebie && !ruleString) return null;

    var thresholdCents = Number(getProp(props, '_club_freebie_threshold_cents') || 0);
    var thresholdEur = Number(getProp(props, '_club_freebie_threshold') || 0);
    var code = String(getProp(props, '_club_freebie_code') || '').trim();

    if (!thresholdCents && thresholdEur) {
      thresholdCents = Math.round(thresholdEur * 100);
    }

    if ((!thresholdCents || !code) && ruleString) {
      var parsed = parseFreebieRuleString(ruleString);
      if (parsed) {
        thresholdCents = thresholdCents || parsed.thresholdCents;
        code = code || parsed.discountCode;
      }
    }

    if (!thresholdCents || !code) return null;

    return {
      thresholdCents: thresholdCents,
      discountCode: code
    };
  }

  function getFreebieEntries(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items
      .map(function (item, index) {
        return {
          item: item,
          index: index,
          rule: getFreebieRuleFromItem(item)
        };
      })
      .filter(function (entry) {
        return !!entry.rule;
      });
  }

  function pickFreebieToKeep(freebieEntries) {
    if (!freebieEntries.length) return null;

    // Newest wins: the most recently added freebie is the last line item in the
    // cart, so keep the entry with the highest index and drop the rest.
    return freebieEntries.reduce(function (newest, entry) {
      return entry.index > newest.index ? entry : newest;
    });
  }

  function getEligibleTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      if (getFreebieRuleFromItem(item)) return sum;
      return sum + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function getCartDiscountCodes(cart) {
    var codes = [];

    function pushCode(value) {
      var code = String(value || '').trim();
      if (!code) return;

      var exists = codes.some(function (existing) {
        return existing.toUpperCase() === code.toUpperCase();
      });

      if (!exists) codes.push(code);
    }

    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        pushCode(discount.code);
      });
    }

    if (!codes.length && cart && Array.isArray(cart.discount_applications)) {
      cart.discount_applications.forEach(function (application) {
        if (application.type === 'discount_code') {
          pushCode(application.code || application.title);
        }
      });
    }

    return codes;
  }

  function getKnownCodesFromCart(cart) {
    var raw = cart && cart.attributes
      ? String(cart.attributes[KNOWN_CODES_ATTRIBUTE] || '').trim()
      : '';

    if (!raw) return [];

    return raw.split(',')
      .map(function (code) { return String(code || '').trim(); })
      .filter(Boolean);
  }

  function uniqueCodes(codes) {
    var unique = [];

    codes.forEach(function (code) {
      var clean = String(code || '').trim();
      if (!clean) return;

      var exists = unique.some(function (existing) {
        return existing.toUpperCase() === clean.toUpperCase();
      });

      if (!exists) unique.push(clean);
    });

    return unique;
  }

  function isPrefixedFreebieCode(code, config) {
    var upperCode = String(code || '').toUpperCase();
    if (!upperCode) return false;

    return config.codePrefixes.some(function (prefix) {
      return upperCode.indexOf(prefix) === 0;
    });
  }

  function isKnownFreebieCode(code, knownCodes, config) {
    var upperCode = String(code || '').toUpperCase();
    if (!upperCode) return false;

    var known = knownCodes.some(function (knownCode) {
      return String(knownCode || '').toUpperCase() === upperCode;
    });

    return known || isPrefixedFreebieCode(code, config);
  }

  function buildDiscountString(cart, wantedFreebieCode, knownCodes, config) {
    var currentCodes = getCartDiscountCodes(cart);
    var preserved = currentCodes.filter(function (code) {
      return !isKnownFreebieCode(code, knownCodes, config);
    });

    if (wantedFreebieCode) {
      preserved.push(wantedFreebieCode);
    }

    return uniqueCodes(preserved).join(',');
  }

  function getCurrentFreebieCodes(cart, knownCodes, config) {
    return getCartDiscountCodes(cart).filter(function (code) {
      return isKnownFreebieCode(code, knownCodes, config);
    });
  }

  function formatMoney(cents, currency, locale) {
    var value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale || 'lt-LT', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return value.toFixed(2) + ' €';
    }
  }

  function getVisibleCardRules() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-club-freebie-card]'))
      .map(function (card) {
        return {
          card: card,
          variantId: Number(card.getAttribute('data-variant-id') || 0),
          thresholdCents: Number(card.getAttribute('data-threshold-cents') || 0),
          thresholdEur: String(card.getAttribute('data-threshold-eur') || '').trim(),
          discountCode: String(card.getAttribute('data-discount-code') || '').trim()
        };
      })
      .filter(function (entry) {
        return entry.variantId && entry.thresholdCents && entry.discountCode;
      });
  }

  function updateSectionButtons(cart, config) {
    var cardRules = getVisibleCardRules();
    if (!cardRules.length) return;

    var freebieEntries = getFreebieEntries(cart);
    var selected = freebieEntries[0] || null;
    var selectedVariantId = selected ? getVariantId(selected.item) : null;
    var eligibleTotal = getEligibleTotal(cart);
    var texts = config.texts || {};

    cardRules.forEach(function (entry) {
      var card = entry.card;
      var button = card.querySelector('[data-club-freebie-add]');
      var textNode = card.querySelector('[data-button-text]');
      if (!button || !textNode) return;

      button.disabled = false;
      button.classList.remove('is-disabled', 'is-locked', 'is-in-cart', 'is-other-gift', 'is-loading');

      if (!config.customerAllowed) {
        button.classList.add('is-locked');
        textNode.textContent = texts.login || 'Prisijungti prie Klubo';
        return;
      }

      if (selectedVariantId && selectedVariantId === entry.variantId) {
        button.disabled = true;
        button.classList.add('is-in-cart');
        textNode.textContent = texts.inCart || 'Dovana jau krepšelyje';
        return;
      }

      // A different freebie may already be selected, but the customer is still
      // allowed to switch: other cards stay clickable and show their normal
      // add/unlock state. Clicking one removes the previous freebie (see
      // handleFreebieButtonClick) so only one club freebie ever remains.

      if (eligibleTotal >= entry.thresholdCents) {
        textNode.textContent = texts.unlocked || 'Atsiimti dovaną';
        return;
      }

      if (config.allowPreThresholdAdd) {
        textNode.textContent = texts.preThresholdAdd || 'Pasirinkti dovaną';
        return;
      }

      button.disabled = true;
      button.classList.add('is-disabled');
      textNode.textContent = (texts.missing || 'Trūksta [amount]').replace(
        '[amount]',
        formatMoney(entry.thresholdCents - eligibleTotal, config.currency, config.locale)
      );
    });
  }

  function getUpcartCartItems() {
    var selector = 'li.upcart-internal-cart-item, li.upcart-public-cart-item';
    var found = [];

    function collect(root) {
      if (root && typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(selector).forEach(function (el) {
          if (found.indexOf(el) === -1) found.push(el);
        });
      }
    }

    collect(document);

    // Also look inside Upcart's root in case it renders in a shadow root.
    var upRoot = window.upcartDocumentOrShadowRoot;
    if (upRoot && upRoot !== document) {
      collect(upRoot);
    }

    return found;
  }

  function getCartItemVariantId(li) {
    var link = li.querySelector('a[href*="variant="]');
    if (!link) return 0;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      return Number(url.searchParams.get('variant') || 0);
    } catch (error) {
      return 0;
    }
  }

  function liHasFreebieCode(li, freebieCodes) {
    if (!freebieCodes.length) return false;

    var tags = li.querySelectorAll('[class*="component-tag__text"]');

    for (var i = 0; i < tags.length; i++) {
      var text = String(tags[i].textContent || '').trim().toUpperCase();
      if (freebieCodes.indexOf(text) !== -1) return true;
    }

    return false;
  }

  function markFreebieLi(li) {
    li.classList.add('club-freebie-upcart-item');
    li.setAttribute('data-club-freebie-item', '');

    li
      .querySelectorAll(
        '.upcart-internal-component-product-tile__quantity-selector button,' +
        '.upcart-public-component-product-tile__quantity-selector button,' +
        '.upcart-internal-component-product-tile__quantity-selector input,' +
        '.upcart-public-component-product-tile__quantity-selector input'
      )
      .forEach(function (control) {
        control.setAttribute('tabindex', '-1');
        control.setAttribute('aria-disabled', 'true');
        if ('disabled' in control) {
          control.disabled = true;
        }
      });
  }

  function markUpcartFreebieItems(cart) {
    injectUpcartCss();

    var freebieEntries = getFreebieEntries(cart || {});

    // How many freebie lines exist per variant, and the freebie codes in play.
    var remaining = {};
    var freebieCodes = [];

    freebieEntries.forEach(function (entry) {
      var variantId = getVariantId(entry.item);
      remaining[variantId] = (remaining[variantId] || 0) + 1;

      var code = String(entry.rule.discountCode || '').trim().toUpperCase();
      if (code && freebieCodes.indexOf(code) === -1) {
        freebieCodes.push(code);
      }
    });

    var items = getUpcartCartItems();

    // Reset previous marks so regular products are never left flagged.
    items.forEach(function (li) {
      li.classList.remove('club-freebie-upcart-item');
      li.removeAttribute('data-club-freebie-item');
    });

    // Pass 1 — prefer lines that actually display a club freebie discount code.
    // When the same variant exists as both a freebie and a full-price item, only
    // the discounted (freebie) line carries the CLUBFREE… tag, so the paid line
    // is left untouched.
    items.forEach(function (li) {
      var variantId = getCartItemVariantId(li);
      if (remaining[variantId] > 0 && liHasFreebieCode(li, freebieCodes)) {
        markFreebieLi(li);
        remaining[variantId] -= 1;
      }
    });

    // Pass 2 — fill any still-unaccounted freebie lines (e.g. pre-threshold,
    // before a code is applied) with remaining unmarked lines of that variant.
    items.forEach(function (li) {
      if (li.classList.contains('club-freebie-upcart-item')) return;

      var variantId = getCartItemVariantId(li);
      if (remaining[variantId] > 0) {
        markFreebieLi(li);
        remaining[variantId] -= 1;
      }
    });
  }

  async function rememberCodesIfNeeded(cart, freebieEntries) {
    var existing = getKnownCodesFromCart(cart);
    var fromItems = freebieEntries.map(function (entry) {
      return entry.rule.discountCode;
    });
    var merged = uniqueCodes(existing.concat(fromItems));

    if (merged.length === existing.length && merged.every(function (code, index) {
      return String(code).toUpperCase() === String(existing[index]).toUpperCase();
    })) {
      return cart;
    }

    return updateKnownCodesAttribute(merged);
  }

  async function normalizeFreebies(cart) {
    var freebieEntries = getFreebieEntries(cart);

    if (!freebieEntries.length) {
      return {
        cart: cart,
        changed: false
      };
    }

    var keepEntry = pickFreebieToKeep(freebieEntries);
    var keepKey = keepEntry && keepEntry.item ? keepEntry.item.key : null;
    var changed = false;

    for (var i = 0; i < freebieEntries.length; i++) {
      var entry = freebieEntries[i];
      var item = entry.item;

      if (!keepKey || item.key !== keepKey) {
        await changeLine(item.key, 0);
        changed = true;
        continue;
      }

      if (Number(item.quantity || 0) > 1) {
        await changeLine(item.key, 1);
        changed = true;
      }
    }

    if (changed) {
      cart = await fetchCart();
    }

    return {
      cart: cart,
      changed: changed
    };
  }

  async function enforceDiscount(cart, config) {
    var freebieEntries = getFreebieEntries(cart);
    var knownCodes = getKnownCodesFromCart(cart);
    var currentFreebieCodes = getCurrentFreebieCodes(cart, knownCodes, config);
    var selected = freebieEntries[0] || null;
    var eligibleTotal = getEligibleTotal(cart);
    var wantedCode = '';

    if (config.customerAllowed && selected && eligibleTotal >= selected.rule.thresholdCents) {
      wantedCode = selected.rule.discountCode;
    }

    var alreadyCorrect =
      currentFreebieCodes.length === (wantedCode ? 1 : 0) &&
      (!wantedCode || String(currentFreebieCodes[0]).toUpperCase() === String(wantedCode).toUpperCase());

    if (alreadyCorrect) {
      return {
        cart: cart,
        changed: false
      };
    }

    var discountString = buildDiscountString(cart, wantedCode, knownCodes, config);
    var updatedCart = await updateDiscounts(discountString);

    return {
      cart: updatedCart,
      changed: true
    };
  }

  function notifyCartChanged(cart) {
    [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'theme:cart:reload',
      'ajaxProduct:added',
      'product:added',
      'upcart:updated',
      'upcart:refresh'
    ].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: {
          cart: cart,
          openCart: true,
          openMiniCart: true
        }
      }));
    });

    window.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));

    // Upcart ignores discount-only /cart/update.js calls, so a discount that the
    // guard applies/removes does not redraw the drawer on its own. Force Upcart to
    // re-fetch and re-render so the freebie visibly goes free / un-free.
    if (typeof window.upcartRefreshCart === 'function') {
      try {
        window.upcartRefreshCart();
      } catch (error) {}
    }
  }

  async function runGuard(reason) {
    if (isRunning) {
      isQueued = true;
      return;
    }

    isRunning = true;

    try {
      var config = getConfig();
      var cart = await fetchCart();
      var changed = false;
      var freebieEntries = getFreebieEntries(cart);

      cart = await rememberCodesIfNeeded(cart, freebieEntries);

      var normalized = await normalizeFreebies(cart);
      cart = normalized.cart;
      changed = changed || normalized.changed;

      var discountResult = await enforceDiscount(cart, config);
      cart = discountResult.cart;
      changed = changed || discountResult.changed;

      updateSectionButtons(cart, config);
      markUpcartFreebieItems(cart);

      if (changed) {
        notifyCartChanged(cart);
      }
    } catch (error) {
      console.warn('[ClubFreebieGuard] Error:', reason, error);
    } finally {
      isRunning = false;

      if (isQueued) {
        isQueued = false;
        queueRun('queued', 350);
      }
    }
  }

  function queueRun(reason, delay) {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(function () {
      runGuard(reason || 'manual');
    }, delay || 250);
  }

  function queueUiUpdate(delay) {
    clearTimeout(uiDebounceTimer);

    uiDebounceTimer = setTimeout(function () {
      fetchCart()
        .then(function (cart) {
          markUpcartFreebieItems(cart);
        })
        .catch(function () {});
    }, delay || 100);
  }

  function handleFreebieButtonClick(event) {
    var button = event.target.closest('[data-club-freebie-add]');
    if (!button) return;

    var card = button.closest('[data-club-freebie-card]');
    if (!card) return;

    event.preventDefault();

    var config = getConfig();
    var variantId = Number(card.getAttribute('data-variant-id') || 0);
    var thresholdEur = String(card.getAttribute('data-threshold-eur') || '').trim();
    var thresholdCents = Number(card.getAttribute('data-threshold-cents') || 0);
    var discountCode = String(card.getAttribute('data-discount-code') || '').trim();

    if (!variantId || !thresholdCents || !discountCode) return;

    if (!config.customerAllowed) {
      window.location.href = config.loginUrl || '/account/login';
      return;
    }

    if (button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    var textNode = button.querySelector('[data-button-text]');
    if (textNode) {
      textNode.textContent = config.texts.adding || 'Pridedama...';
    }

    fetchCart()
      .then(async function (cart) {
        var existingFreebies = getFreebieEntries(cart);
        var eligibleTotal = getEligibleTotal(cart);

        // If this exact gift is already the selected freebie, do nothing.
        var sameAlreadyInCart = existingFreebies.some(function (entry) {
          return getVariantId(entry.item) === variantId;
        });

        if (sameAlreadyInCart) {
          await runGuard('freebie already selected');
          return;
        }

        if (!config.allowPreThresholdAdd && eligibleTotal < thresholdCents) {
          await runGuard('threshold not reached');
          return;
        }

        // Switching gifts: remove any previously selected club freebie first so
        // the newly chosen one becomes the only club freebie in the cart.
        for (var i = 0; i < existingFreebies.length; i++) {
          await changeLine(existingFreebies[i].item.key, 0);
        }

        await addVariantAsFreebie(variantId, thresholdEur, thresholdCents, discountCode);
        cart = await fetchCart();
        await rememberCodesIfNeeded(cart, getFreebieEntries(cart));
        await runGuard('freebie added from section');
      })
      .catch(function (error) {
        console.warn('[ClubFreebieGuard] Add error:', error);
        queueRun('add error', 250);
      });
  }

  function handleBlockedUpcartQuantity(event) {
    // composedPath() crosses shadow boundaries, so this works whether Upcart
    // renders in the light DOM or a shadow root.
    var path = (event.composedPath && event.composedPath()) || [event.target];
    var inFreebie = false;
    var inQuantity = false;

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.classList) continue;

      var cls = String(node.className || '');

      if (node.classList.contains('club-freebie-upcart-item')) {
        inFreebie = true;
      }

      if (cls.indexOf('QuantityField') !== -1 || cls.indexOf('quantity-selector') !== -1) {
        inQuantity = true;
      }
    }

    if (!inFreebie || !inQuantity) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    queueRun('blocked upcart quantity', 200);
  }

  function patchFetch() {
    if (window.__clubFreebieFetchPatched) return;
    window.__clubFreebieFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = '';

      if (typeof input === 'string') {
        url = input;
      } else if (input && input.url) {
        url = input.url;
      }

      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);

      return originalFetch.apply(this, args).then(function (response) {
        if (isCartMutation) {
          setTimeout(function () {
            queueRun('fetch cart mutation', 450);
            queueUiUpdate(500);
          }, 0);
        }

        return response;
      });
    };
  }

  function patchXHR() {
    if (window.__clubFreebieXHRPatched) return;
    window.__clubFreebieXHRPatched = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__clubFreebieUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__clubFreebieUrl || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);

      if (isCartMutation) {
        xhr.addEventListener('loadend', function () {
          queueRun('xhr cart mutation', 450);
          queueUiUpdate(500);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function observeUpcartDom() {
    if (!document.body || window.__clubFreebieObserverStarted) return;
    window.__clubFreebieObserverStarted = true;

    var observer = new MutationObserver(function (mutations) {
      var shouldTouchUpcart = mutations.some(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) return false;

        return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
          if (!node || node.nodeType !== 1) return false;

          var el = node;
          var className = String(el.className || '').toLowerCase();
          var id = String(el.id || '').toLowerCase();

          return (
            id.indexOf('upcart') !== -1 ||
            className.indexOf('upcart') !== -1 ||
            (el.querySelector &&
              el.querySelector('[id*="upcart"], [class*="upcart"], [id*="Upcart"], [class*="Upcart"]'))
          );
        });
      });

      if (shouldTouchUpcart) {
        queueUiUpdate(150);
        queueRun('upcart dom changed', 800);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function subscribeUpcartEvents(attempt) {
    attempt = attempt || 0;

    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      try {
        window.upcartSubscribeCartUpdated(function () {
          queueUiUpdate(150);
          queueRun('upcart cart updated', 400);
        });
      } catch (error) {}
      return;
    }

    // Upcart may load after this guard, so retry briefly until its API exists.
    if (attempt < 20) {
      setTimeout(function () {
        subscribeUpcartEvents(attempt + 1);
      }, 500);
    }
  }

  function initSliders() {
    document.querySelectorAll('[data-club-freebie-section]').forEach(function (section) {
      var track = section.querySelector('[data-club-freebie-track]');
      var prev = section.querySelector('[data-club-freebie-prev]');
      var next = section.querySelector('[data-club-freebie-next]');

      if (prev && track && !prev.dataset.clubBound) {
        prev.dataset.clubBound = 'true';

        prev.addEventListener('click', function () {
          track.scrollBy({
            left: -280,
            behavior: 'smooth'
          });
        });
      }

      if (next && track && !next.dataset.clubBound) {
        next.dataset.clubBound = 'true';

        next.addEventListener('click', function () {
          track.scrollBy({
            left: 280,
            behavior: 'smooth'
          });
        });
      }

      var progressThumb = section.querySelector('[data-club-freebie-progress]');

      if (track && progressThumb && !track.dataset.clubProgressBound) {
        track.dataset.clubProgressBound = 'true';

        var updateProgress = function () {
          var scrollable = track.scrollWidth - track.clientWidth;
          var visibleFraction = track.scrollWidth > 0
            ? track.clientWidth / track.scrollWidth
            : 1;
          var widthPct = Math.max(12, Math.min(100, visibleFraction * 100));
          var ratio = scrollable > 0 ? track.scrollLeft / scrollable : 0;

          progressThumb.style.width = widthPct + '%';
          progressThumb.style.left = (ratio * (100 - widthPct)) + '%';
        };

        track.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
        updateProgress();
      }
    });
  }

  function buildUpcartCssText() {
    // Only ever targets elements the guard tagged with .club-freebie-upcart-item
    // (matched by exact line key), so same-variant paid products are untouched.
    return [
      'li.club-freebie-upcart-item .upcart-internal-component-product-tile__quantity-selector,',
      'li.club-freebie-upcart-item .upcart-public-component-product-tile__quantity-selector,',
      '.club-freebie-upcart-item [class*="QuantityField"] {',
      '  opacity: 0.8 !important;',
      '  filter: grayscale(1) !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');
  }

  function injectUpcartCss() {
    var css = buildUpcartCssText();

    if (!document.getElementById('club-freebie-upcart-css')) {
      var style = document.createElement('style');
      style.id = 'club-freebie-upcart-css';
      style.textContent = css;
      document.head.appendChild(style);
    }

    // If Upcart renders inside a shadow root, document-level styles can't reach
    // it, so inject a copy there too (root.host distinguishes a ShadowRoot).
    var root = window.upcartDocumentOrShadowRoot;
    if (
      root &&
      root.host &&
      typeof root.appendChild === 'function' &&
      !root.querySelector('#club-freebie-upcart-css-shadow')
    ) {
      var shadowStyle = document.createElement('style');
      shadowStyle.id = 'club-freebie-upcart-css-shadow';
      shadowStyle.textContent = css;
      root.appendChild(shadowStyle);
    }
  }

  document.addEventListener('click', handleFreebieButtonClick);
  document.addEventListener('click', handleBlockedUpcartQuantity, true);
  document.addEventListener('input', handleBlockedUpcartQuantity, true);
  document.addEventListener('change', handleBlockedUpcartQuantity, true);

  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'theme:cart:reload',
    'ajaxProduct:added',
    'product:added',
    'upcart:updated',
    'upcart:refresh'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      queueRun(eventName, 500);
      queueUiUpdate(300);
    });
  });

  patchFetch();
  patchXHR();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectUpcartCss();
      initSliders();
      observeUpcartDom();
      subscribeUpcartEvents();
      queueRun('initial', 150);
      queueUiUpdate(300);
    });
  } else {
    injectUpcartCss();
    initSliders();
    observeUpcartDom();
    subscribeUpcartEvents();
    queueRun('initial', 150);
    queueUiUpdate(300);
  }

  window.ClubFreebieRun = function () {
    queueRun('manual', 0);
  };
})();
